// @styles
require('./aggregatorCredentialsPSD2Styles.scss')

// @vendors
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { OKButton } from 'components/commons/OKButton/OKButton';

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';

// @constants
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys'
const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR_RENEW_SESSION,
    PROC_FAIL,
    PROC_AGGREGATOR,
    PROC_AGGREGATOR_RENEW_ENTITY_RETRY
} = require('utilities/tagging');

class AggregatorCredentialsPSD2Ko extends Component {

    constructor() {
        super();
        const { bankName } = Storage.localStorage.get(SELECTED_BANK) || {};
        this.state = { bankName }
        this.handleGoToGlobalPosition = this.handleGoToGlobalPosition.bind(this);
        this.handleGoToAddBank = this.handleGoToAddBank.bind(this);
    }

    componentDidMount() {
        recordPath(PROC_AGGREGATOR_RENEW_ENTITY_RETRY, null, PROC_AGGREGATOR_RENEW_SESSION, PROC_FAIL);
    }

    handleGoToAddBank = () => {
        recordLink(PROC_AGGREGATOR, PROC_AGGREGATOR_RENEW_ENTITY_RETRY)
        this.props.history.push('/myprofile/global/entities/add')
    }

    handleGoToGlobalPosition = () => this.props.history.push('/myprofile/global')

    render() {
        const { bankName } = this.state

        return (
            <AggregatorAddEntityLayout>
                <OKSectionBox className="aggregator-psd2-credentials col-md-8" title={formatText('aggregatorPSD2-credentialsKoTitle', [bankName || ''])} icon="error">
                    <div className="aggregator-psd2-credentials__information">
                        <FormattedText value="aggregatorPSD2-credentialsKoInformation" />
                    </div>
                    <div className="aggregator-psd2-credentials__buttons-wrapper">
                        <div className="aggregator-psd2-credentials__left-button">
                            <OKButton modifier="ghost" onClick={this.handleGoToAddBank}>
                                <FormattedText value="aggregatorPSD2-credentialsKoRetryButton" />
                            </OKButton>
                        </div>
                        <div className="aggregator-psd2-credentials__right-button">
                            <OKButton modifier="link-complementary" onClick={this.handleGoToGlobalPosition}>
                                <FormattedText value="aggregatorPSD2-credentialsKoBackGlobalPositionButton" />
                            </OKButton>
                        </div>
                        <div className="aggregator-psd2-credentials__clear-float" />
                    </div>
                </OKSectionBox>
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorCredentialsPSD2Ko.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorCredentialsPSD2Ko);
